import { useEffect, useState } from 'react'

/**
 * Custom hook to track viewport height changes.
 * This is zoom-aware and triggers re-renders when user zooms in/out or window resizes.
 *
 * @returns Current window.innerHeight in pixels
 *
 * @example
 * const viewportHeight = useViewportHeight()
 * return <Box height={viewportHeight}>{children}</Box>
 */
export const useViewportHeight = (): number => {
  const [viewportHeight, setViewportHeight] = useState<number>(window.innerHeight)

  useEffect(() => {
    const handleResize = () => {
      setViewportHeight(window.innerHeight)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return viewportHeight
}

export const useRowCount = (rowHeight = 44, extraRows = 15): number => {
  const height = useViewportHeight()
  return Math.floor(height / rowHeight) + extraRows
}
